var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToastFailure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 2.50016C5.8579 2.50016 2.50004 5.85803 2.50004 10.0002C2.50004 14.1423 5.8579 17.5002 10 17.5002C14.1422 17.5002 17.5 14.1423 17.5 10.0002C17.5 5.85803 14.1422 2.50016 10 2.50016ZM0.833374 10.0002C0.833374 4.93755 4.93743 0.833496 10 0.833496C15.0626 0.833496 19.1667 4.93755 19.1667 10.0002C19.1667 15.0628 15.0626 19.1668 10 19.1668C4.93743 19.1668 0.833374 15.0628 0.833374 10.0002Z",
    fill: "#262F40"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99996 5.8335C10.4602 5.8335 10.8333 6.20659 10.8333 6.66683V10.0002C10.8333 10.4604 10.4602 10.8335 9.99996 10.8335C9.53972 10.8335 9.16663 10.4604 9.16663 10.0002V6.66683C9.16663 6.20659 9.53972 5.8335 9.99996 5.8335Z",
    fill: "#262F40"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.16663 13.3333C9.16663 12.8731 9.53972 12.5 9.99996 12.5H10.0083C10.4685 12.5 10.8416 12.8731 10.8416 13.3333C10.8416 13.7936 10.4685 14.1667 10.0083 14.1667H9.99996C9.53972 14.1667 9.16663 13.7936 9.16663 13.3333Z",
    fill: "#262F40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToastFailure);
export default __webpack_public_path__ + "static/media/toast-failure.5ff0e7499c9faa63648c366c70010482.svg";
export { ForwardRef as ReactComponent };